<template>
    <div>
        <Modal v-model="modal" :title="!cloudTrailWarningForm.id ? this.$t('alarms.log.cloudTrail.addCloudTrailAlertRule'):this.$t('alarms.log.cloudTrail.updateCloudTrailAlertRule')" :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="800px" :closable="false">
            <Form ref="cloudTrailWarningForm" :model="cloudTrailWarningForm" :label-width="110" :rules="ruleValidate">
                <!-- 微信警告 -->
                <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
                <!-- 规则名称 -->
                <FormItem :label="this.$t('alarms.common.alertRuleName')" prop="ruleName" v-if="isEditRuleName">
                    <Row>
                        <Col span="11">
                            <Input type="text" v-model="cloudTrailWarningForm.ruleName" placeholder="Enter something..."
                           style="width:300px;" :disabled="isEdit"></Input>
                        </Col>
                     </Row>
                </FormItem>

                <!-- 规则名称 -->
                <FormItem :label="this.$t('alarms.common.alertRuleName')" v-if="showRuleName">
                    <Row>
                        <Col span="24">
                            <div>{{this.cloudTrailWarningForm.ruleName}}</div>
                        </Col>
                    </Row>
                </FormItem>


                <!-- 账户 -->
                <FormItem :label="this.$t('alarms.common.account')" prop="account">
                    <Select v-model="cloudTrailWarningForm.account" filterable :placeholder="this.$t('alarms.common.pleaseSelect')" @on-change="changeAccount(cloudTrailWarningForm.account)" :transfer="true" style="width:300px;">
                        <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 存储区域 -->
                <FormItem :label="this.$t('alarms.common.region')" prop="backupRegion">
                    <Select @on-change="changebackupRegion(cloudTrailWarningForm.backupRegion)" filterable :placeholder="this.$t('alarms.common.pleaseSelect')" v-model="cloudTrailWarningForm.backupRegion" multiple :max-tag-count="1" :transfer="true" style="width:300px;">
                        <Checkbox v-model="singleBackupRegion" @on-change="selectBackupRegionAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                        <Option :value="item.name" v-for="item in backupRegionList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 事件检查 -->
                <FormItem :label="this.$t('alarms.log.cloudTrail.eventCheck')" prop="cloudTrailNames">
                    <Select @on-change="changeCloudTrailNames(cloudTrailWarningForm.cloudTrailNames)" filterable :placeholder="this.$t('alarms.common.pleaseSelect')" v-model="cloudTrailWarningForm.cloudTrailNames" multiple :max-tag-count="1" :transfer="true" style="width:300px;">
                        <Checkbox v-model="singleCloudTrailNames" @on-change="selectCloudTrailNamesAll" style="display: block;text-align:right;">{{ $t('alarms.common.all') }}</Checkbox>
                        <Option :value="item.awsEventName" v-for="(item,index) in cloudTrailNamesList" :key="index">{{item.awsEventName}}</Option>
                    </Select>
                </FormItem>


                <!-- 规则描述 -->
                <FormItem :label="this.$t('alarms.common.alertRuleDesc')">
                    <Row :gutter="4">
                        <!-- 监控指标 -->
                        <Col span="6">
                            <FormItem prop="monitorIndex">
                                <Select v-model="cloudTrailWarningForm.monitorIndex" filterable @on-change="changeMonitorIndex(cloudTrailWarningForm.monitorIndex)" :placeholder="this.$t('alarms.common.monitorIndex')">
                                    <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 周期 -->
                        <Col span="3">
                            <FormItem prop="cycle">
                                <Select v-model="cloudTrailWarningForm.cycle" filterable :placeholder="this.$t('alarms.common.cycle')" @on-change="changeCycle(cloudTrailWarningForm.cycle)">
                                    <Option :value="item.id" v-for="(item,index) in cycleList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 连续周期 -->
                        <Col span="4">
                            <FormItem prop="continousCycle">
                                <Select v-model="cloudTrailWarningForm.continousCycle" filterable :placeholder="this.$t('alarms.common.continuous')"
                                      @on-change="changeContinousCycle(cloudTrailWarningForm.continousCycle)">
                                    <Option :value="item.id" v-for="(item,index) in continousCycleList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <!-- 统计数值 -->
                        <Col span="4">
                            <FormItem prop="statisticsValue">
                                <Select v-model="cloudTrailWarningForm.statisticsValue" filterable :placeholder="this.$t('alarms.common.statisticsValue')"
                                  @on-change="changeStatisticsValue(cloudTrailWarningForm.statisticsValue)">
                                    <Option :value="item.id" v-for="(item,index) in statisticsValueList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                        </Col>


                        <!-- 如果监控指标为集群状态（黄色）、集群状态（红色）、主节点时 不显示符号、阈值和单位 -->
                        <div v-if="this.isShowField!=1">
                            <!-- 关系符号 -->
                            <Col span="2">
                                <FormItem prop="relationshipSign">
                                    <Select v-model="cloudTrailWarningForm.relationshipSign" filterable
                                            @on-change="changeRelationshipSign(cloudTrailWarningForm.relationshipSign)" :placeholder="this.$t('alarms.common.sign')">
                                        <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 阈值 -->
                            <Col span="2">
                                <FormItem prop="thresholdValue">
                                    <Input v-model="cloudTrailWarningForm.thresholdValue" :placeholder="this.$t('alarms.common.threshold')"
                                       type="number"></Input>
                                </FormItem>
                            </Col>
                            <!-- 单位 -->
                            <Col span="2">
                                <FormItem prop="unit">
                                    <Input v-model="cloudTrailWarningForm.unit" disabled :placeholder="this.$t('alarms.common.unit')"></Input>
                                </FormItem>
                            </Col>
                        </div>
                        <div v-else-if="this.isShowField==2">
                            <!-- 关系符号 -->
                            <Col span="2">
                                <FormItem prop="relationshipSign">
                                    <Select v-model="cloudTrailWarningForm.relationshipSign" filterable  @on-change="changeRelationshipSign(cloudTrailWarningForm.relationshipSign)"
                                            :placeholder="this.$t('alarms.common.sign')">
                                        <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">{{item.name}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!-- 阈值 -->
                            <Col span="2">
                                <FormItem prop="thresholdValue">
                                    <Input v-model="cloudTrailWarningForm.thresholdValue" :placeholder="this.$t('alarms.common.threshold')" type="number"></Input>
                                </FormItem>
                            </Col>
                            <!-- 单位 -->
                            <Col span="2">
                                <FormItem prop="unit">
                                    <Input v-model="cloudTrailWarningForm.unit" disabled :placeholder="this.$t('alarms.common.unit')"></Input>
                                </FormItem>
                            </Col>
                        </div>
                    </Row>
                </FormItem>

                <!-- 联系方式 -->
                <FormItem :label="this.$t('alarms.billing.contactWay')" prop="contactType">
                    <RadioGroup v-model="cloudTrailWarningForm.contactType" @on-change="changeContactType(cloudTrailWarningForm.contactType)" >
                        <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
                    </RadioGroup>
                </FormItem>

                <!-- 通知对象 -->
                <FormItem :label="this.$t('alarms.common.contact')" prop="notificationObject" v-if="cloudTrailWarningForm.contactType==0">
                    <Select v-model="cloudTrailWarningForm.notificationObject" filterable multiple style="width:300px;" @on-change="changeNotificationObject" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 联系人组 -->
                <FormItem :label="this.$t('alarms.common.alertContactGroup')" prop="contactGroupIds" v-if="cloudTrailWarningForm.contactType==1">
                    <Select v-model="cloudTrailWarningForm.contactGroupIds" filterable multiple style="width:300px;" @on-change="changeContactGroupId(cloudTrailWarningForm.contactGroupIds)" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 报警方式 -->
                <FormItem :label="this.$t('alarms.common.alarmType')" prop="noticeType">
                    <Select v-model="cloudTrailWarningForm.noticeType" filterable multiple style="width:300px;" @on-change="selectnoticeType(cloudTrailWarningForm.noticeType)" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 企业微信机器人URL -->
                <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="cloudTrailWarningForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
                    <Select v-model="cloudTrailWarningForm.enterpriseWechatRobotIds" filterable multiple style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>


                <!-- 延迟告警 -->
                <FormItem :label="this.$t('alarms.common.delayAlarm')" prop="alarmDelay">
                    <Select v-model="cloudTrailWarningForm.alarmDelay" filterable style="width:300px;" :placeholder="this.$t('alarms.common.pleaseSelect')">
                        <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

              <!-- 监控时段 -->
              <FormItem :label="this.$t('alarms.common.monitoringTime')" prop="monitorPeriod">
                <Select v-model="cloudTrailWarningForm.monitorPeriod" filterable style="width:300px;" :placeholder="this.$t('alarms.common.pleaseSelect')">
                  <Option v-for="item in monitorPeriodList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>

                <!-- 邮箱模板 -->
                <div v-show="isShowEmail">
                    <FormItem :label="this.$t('alarms.common.emailTemplate')" prop="emailModal">
                        <Input v-model="cloudTrailWarningForm.emailModal" type="textarea"
                         :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
                    </FormItem>
                </div>

                <!-- 企业微信模板 -->
                <div v-show="isShowWeChat">
                    <FormItem :label="this.$t('alarms.common.weChatTemplate')" prop="wechatModal">
                        <Input v-model="cloudTrailWarningForm.wechatModal" type="textarea"
                         :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
                    </FormItem>
                </div>
            </Form>
            <div slot="footer">
                <Button size="large" @click="cancel('cloudTrailWarningForm')">{{ $t('alarms.common.cancel') }}</Button>
                <Button type="primary" size="large" @click="ok('cloudTrailWarningForm')" :loading="addloading" :disabled="isAddOrEdit">
                  {{!cloudTrailWarningForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}
                </Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import WechatWarning from '../../../common/WechatWarning.vue'
    import {setCookie, getCookie} from '../../../../../utils/cookieUtil.js'
    import TableCloudTrailWarning from '../cloudTrail_monitor/TableCloudTrailWarning.vue'

    var tableCloudTrailWarning = TableCloudTrailWarning;
    var tableCloudTrailWarningVue = {}
    export default {
        inject: ['reload'],
        components: {
            WechatWarning
        },
        data() {
            // 名字是否重复
            var validNameRepeatedCheck = (rule, value, callback) => {
                var self = this;
                self.$api.alertRule.nameRepeatedCheck({
                    "alertRuleName": this.cloudTrailWarningForm.ruleName,
                    "monitorModule": this.monitorModule
                })
                .then(res => {
                    if (res.status == 200) {
                        callback();
                    }
                })
                .catch(err => {
                    if (err.status == 400) {
                        callback(new Error('规则名称不能重复!'));
                    }
                })
            };
            return {
                monitorModule:9,
                addloading:false,
                isAddOrEdit:true,
                wechatWarningVisible: false,
                contactTypeList: [{
                    label: this.$t('alarms.common.alertContact'),
                    value: 'contact',
                    type: 0
                },
                {
                    label: this.$t('alarms.common.alertContactGroup'),
                    value: 'contactGroup',
                    type: 1
                }],
                isShowField: '', //是否显示符号、阈值和单位
                singleBackupRegion:false,
                singleCloudTrailNames:false,
                alarmDelayList:[],
              monitorPeriodList:[],
                isEdit: false,
                isEditRuleName: false,
                showRuleName: false,
                isShowEmail: false,
                isShowWeChat: false,
                accountList: [],
                notificationObjectList: [],
                alarmWayList: [],
                backupRegionList: [],
                cloudTrailNamesList: [],
                loading: true,
                modal: false,
                modal_loading: false,
                exportDataList: '',
                noticeType: [],
                units: '',
                unit: '',
                cloudTrailWarningForm: {
                    account: '',
                    ruleName: '',
                    notificationObject: [],
                    noticeType: [],
                    emailModal: '',
                    wechatModal: '',
                    thresholdValue: '',
                    monitorIndex: '',
                    cycle: '',
                    continousCycle: '',
                    statisticsValue: '',
                    relationshipSign: '',
                    unit: '',
                    backupRegion: [],
                    cloudTrailNames: [],
                    alarmDelay:'',
                    monitorPeriod:'',
                    contactType:0,
                    contactGroupIds:[],
                    userIdList:[],
                    enterpriseWechatRobotIds:[]
                },
                enterpriseWechatRobotIdsList:[],
                // 联系人组
                contactGroupIdList:[],
                // 监控指标
                monitorIndexList: [],
                // 周期
                cycleList: [],
                // 连续周期
                continousCycleList: [],
                // 统计数值
                statisticsValueList: [],
                // 关系符号
                relationshipSignList: [],
                ruleValidate: {
                    account: [
                        {required: true, message: '请选择账户名称', trigger: 'change', type: 'number'}
                    ],
                    alarmDelay: [
                        {required: true, message: '请选择延迟告警', trigger: 'change', type: 'number'}
                    ],
                  monitorPeriod: [
                    {required: true, message: '请选择监控时段', trigger: 'change', type: 'number'}
                  ],
                    backupRegion: [
                        {required: true, type: 'array', message: '请选择存储区域', trigger: 'change'}
                    ],
                    cloudTrailNames: [
                        {required: true, type: 'array', message: '请选择事件检查', trigger: 'change'}
                    ],
                    ruleName: [
                        {required: true, message: '规则名称不能为空', trigger: 'blur'},
                        {type: 'string', message: '规则名称为2-20个字符首尾中间不能有空格', pattern: '^[^ ]{2,20}$', trigger: 'blur'},
                        {validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    notificationObject: [
                        {required: true, type: 'array', message: '请选择通知对象', trigger: 'change'}
                    ],
                    noticeType: [
                        {required: true, type: 'array', min: 1, message: '请选择报警方式', trigger: 'change'}
                    ],
                    monitorIndex: [
                        {required: true, message: '请选择监控指标', trigger: 'change', type: 'number'}
                    ],
                    cycle: [
                        {required: true, message: '请选择周期', trigger: 'change', type: 'number'}
                    ],
                    continousCycle: [
                        {required: true, message: '请选择连续周期', trigger: 'change', type: 'number'}
                    ],
                    statisticsValue: [
                        {required: true, message: '请选择统计数值', trigger: 'change', type: 'number'}
                    ],
                    relationshipSign: [
                        {required: true, message: '请选择关系符号', trigger: 'change', type: 'number'}
                    ],
                    thresholdValue: [
                        {required: true, message: '请输入阈值'}
                    ],
                    contactType: [
                        {required: true, message: '请选择联系方式', trigger: 'change', type: 'number'}
                    ],
                    contactGroupIds: [
                        {required: true, message: '请选择联系人组', trigger: 'change', type: 'array'}
                    ],
                    enterpriseWechatRobotIds: [
                        {required: true, type: 'array', message: '请选择企业微信机器人URL', trigger: 'change'}
                    ]
                }
            }
        },

        beforeCreate: function () {
            tableCloudTrailWarningVue = this
        },
        methods: {
            //显示表格数据
            /****************************************************************/
            init: function (id) {
                this.cloudTrailWarningForm.id = id || 0;
                // 根据用户名查询Account列表
                tableCloudTrailWarningVue.getAccount();
                this.$nextTick(() => {
                    // 重置表单
                    this.$refs['cloudTrailWarningForm'].resetFields();
                    // 编辑
                    if (this.cloudTrailWarningForm.id) {
                        // 编辑显示不能输入的规则名称
                        this.showRuleName = true;
                        this.isEdit = true;
                        this.$api.alertRule.selectAlertRule("id", this.cloudTrailWarningForm.id)
                            .then(res => {
                                //延时
                                this.cloudTrailWarningForm.alarmDelay = res.data.delay;
                                //监控时段
                                this.cloudTrailWarningForm.monitorPeriod = res.data.monitorPeriod;
                                // 账户
                                /******************************************************/
                                this.cloudTrailWarningForm.account = res.data.accountId;
                                // 存储区域
                                tableCloudTrailWarningVue.$api.account.queryAccountRegions("accountId", this.cloudTrailWarningForm.account)
                                .then(res => {
                                    this.backupRegionList = res.data;
                                });

                                tableCloudTrailWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                                    "monitorModule":this.monitorModule,
                                    "accountId":this.cloudTrailWarningForm.account
                                })
                                .then(res => {
                                  this.notificationObjectList = res.data.contactList;
                                });

                                setTimeout(() => {
                                    this.cloudTrailWarningForm.backupRegion = res.data.regions;
                                }, 1000)

                                // 规则名称
                                this.cloudTrailWarningForm.ruleName = res.data.alertRuleName;

                                // 监控指标
                                /******************************************************/
                                // 查询监控指标
                                tableCloudTrailWarningVue.$api.alertRule.searchMonitorIndex({
                                    "monitorModule":this.monitorModule,
                                    "accountId":this.cloudTrailWarningForm.account
                                })
                                .then(res => {
                                    this.monitorIndexList = res.data;
                                })
                                this.cloudTrailWarningForm.monitorIndex = res.data.monitorIndex;
                                // 如果监控指标为CloudTrail异常事件时 不显示符号、阈值和单位
                                if (this.cloudTrailWarningForm.monitorIndex == 54) {
                                    this.isShowField = 1;
                                } else {
                                    this.isShowField = 2;
                                }

                                // 周期
                                this.cloudTrailWarningForm.cycle = res.data.cycle;
                                // 连续周期
                                this.cloudTrailWarningForm.continousCycle = res.data.continousCycle;
                                // 统计数值
                                this.cloudTrailWarningForm.statisticsValue = res.data.statisticsValue;
                                // 符号
                                this.cloudTrailWarningForm.relationshipSign = res.data.relationshipSign;
                                // 阈值
                                this.cloudTrailWarningForm.thresholdValue = res.data.thresholdValue;
                                // 事件检查
                                this.cloudTrailWarningForm.cloudTrailNames = res.data.cloudTrailNames;
                                // 单位
                                this.cloudTrailWarningForm.unit = res.data.unit;
                                this.units = res.data.unitId;
                                // 企业微信机器人URL
                                this.cloudTrailWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

                                // 联系方式
                                this.cloudTrailWarningForm.contactType = res.data.contactType;
                                if(res.data.contactType==0){
                                    // 通知对象
                                    this.cloudTrailWarningForm.notificationObject = res.data.contactIDs;
                                    for(var i=0;i<this.cloudTrailWarningForm.notificationObject.length;i++){
                                        for(var j=0;j<this.notificationObjectList.length;j++){
                                            if(this.cloudTrailWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                                                this.cloudTrailWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                                            }
                                        }
                                    }
                                }else if(res.data.contactType==1){
                                    // 联系人组
                                    this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.cloudTrailWarningForm.account)
                                    .then(res => {
                                        this.contactGroupIdList = res.data;
                                    })
                                    setTimeout(() => {
                                        this.cloudTrailWarningForm.contactGroupIds = res.data.contactGroupIds;
                                    }, 1000)
                                }
                                // 查询阈值
                                tableCloudTrailWarningVue.selectMonitorIndexDefault();

                                // 报警方式
                                this.cloudTrailWarningForm.noticeType = res.data.noticeType;

                                for (var i = 0; i < this.cloudTrailWarningForm.noticeType.length; i++){
                                    if (this.cloudTrailWarningForm.noticeType[i] == '0') {
                                        this.isShowEmail = true;
                                        this.cloudTrailWarningForm.emailModal = res.data.briefReportBodyMail;
                                        this.noticeType = this.cloudTrailWarningForm.noticeType;
                                        tableCloudTrailWarningVue.selectTemplate();
                                    }
                                    if (this.cloudTrailWarningForm.noticeType[i] == '1') {
                                        // this.isShowWeChat = true;
                                        this.cloudTrailWarningForm.wechatModal = res.data.briefReportBodyWechat;
                                        this.checkLeastOnePersonBoundWeChat();
                                        this.noticeType = this.cloudTrailWarningForm.noticeType;
                                        tableCloudTrailWarningVue.selectTemplate();
                                    }else if(this.cloudTrailWarningForm.noticeType[i]!='1'){
                                      this.wechatWarningVisible=false;
                                      this.isAddOrEdit=false;
                                  }
                                }
                            })
                    } else {
                        this.isEdit = false;
                        // 添加显示规则名称能输入
                        this.isEditRuleName = true;
                        this.showRuleName = false;
                    }
                })
                this.modal = true;
            },
            // 根据监控指标 显示不同单位
            /****************************************************************/
            // 清空周期、连续周期、统计数值、关系符号
            emptyDate: function () {
                this.cloudTrailWarningForm.cycle = '';
                this.cloudTrailWarningForm.continousCycle = '';
                this.cloudTrailWarningForm.statisticsValue = '';
                this.cloudTrailWarningForm.relationshipSign = '';
                this.cloudTrailWarningForm.thresholdValue = '';
            },
            isNotEmpty: function (obj) {
                if (typeof obj === "undefined" || obj === null || obj === "") {
                    return false;
                } else {
                    return true;
                }
            },
            // 根据监控指标 显示不同单位
            changeMonitorIndex: function () {
                // 如果监控指标为CloudTrail异常事件时 不显示符号、阈值和单位
                if (this.cloudTrailWarningForm.monitorIndex == 54) {
                    this.isShowField = 1;
                } else {
                    this.isShowField = 2;
                }
                tableCloudTrailWarningVue.selectMonitorIndexDefault();
                this.unit = this.cloudTrailWarningForm.monitorIndex;
                for (var i = 0; i < this.monitorIndexList.length; i++) {
                    if (this.monitorIndexList[i].id == this.unit) {
                        this.cloudTrailWarningForm.unit = this.monitorIndexList[i].unit;
                        this.units = this.monitorIndexList[i].id;
                    }
                }
                tableCloudTrailWarningVue.selectTemplate();
                tableCloudTrailWarningVue.emptyDate();
            },
            // 查询阈值
            /****************************************************************/
            selectMonitorIndexDefault: function () {
                tableCloudTrailWarningVue.$api.alertRule.selectMonitorIndexDefault({
                    "monitorIndex": this.cloudTrailWarningForm.monitorIndex,
                    "monitorModule": this.monitorModule,
                    "cycle": this.cloudTrailWarningForm.cycle,
                    "continousCycle": this.cloudTrailWarningForm.continousCycle,
                    "statisticsValue": this.cloudTrailWarningForm.statisticsValue,
                    "relationshipSign": this.cloudTrailWarningForm.relationshipSign
                })
                .then(res => {
                    // 周期
                    this.cycleList = res.data.cycleMap;
                    // 连续周期
                    this.continousCycleList = res.data.continousCycleMap;
                    // 统计数值
                    this.statisticsValueList = res.data.statisticsValueMap;
                    // 关系符号
                    this.relationshipSignList = res.data.relationshipSignMap;
                    // 阈值
                    if (res.data.companyMonitoritemVariablesList.length == 1 && tableCloudTrailWarningVue.isNotEmpty(this.cloudTrailWarningForm.cycle) && tableCloudTrailWarningVue.isNotEmpty(this.cloudTrailWarningForm.continousCycle) && tableCloudTrailWarningVue.isNotEmpty(this.cloudTrailWarningForm.statisticsValue) && tableCloudTrailWarningVue.isNotEmpty(this.cloudTrailWarningForm.relationshipSign) && this.cloudTrailWarningForm.id == 0) {
                        this.cloudTrailWarningForm.thresholdValue = res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
                    }

                })
            },
            // 查询邮件模板
            /****************************************************************/
            selectTemplate: function () {
                tableCloudTrailWarningVue.$api.briefReport.selectTemplate({
                    "monitorIndex": this.cloudTrailWarningForm.monitorIndex,
                    "relationshipSign": this.cloudTrailWarningForm.relationshipSign,
                    "monitorModule": this.monitorModule,
                    "noticeType": this.cloudTrailWarningForm.noticeType
                })
                .then(res => {
                    this.cloudTrailWarningForm.wechatModal = res.data.briefReportBodyWechat;
                    this.cloudTrailWarningForm.emailModal = res.data.briefReportBodyMail;
                })
            },
            //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
            selectnoticeType: function () {
                this.isShowEmail = false;
                this.isShowWeChat = false;
                for(var i=0;i<this.cloudTrailWarningForm.noticeType.length;i++) {
                    if (this.cloudTrailWarningForm.noticeType[i] == '0') {
                        this.isShowEmail = true;
                        this.noticeType = this.cloudTrailWarningForm.noticeType;
                        tableCloudTrailWarningVue.selectTemplate();
                    }
                    if (this.cloudTrailWarningForm.noticeType[i] == '1') {
                        // this.isShowWeChat = true;
                        this.noticeType = this.cloudTrailWarningForm.noticeType;
                        this.checkLeastOnePersonBoundWeChat();
                        tableCloudTrailWarningVue.selectTemplate();
                    }else if(this.cloudTrailWarningForm.noticeType[i]!='1'){
                        this.wechatWarningVisible=false;
                        this.isAddOrEdit=false;
                    }
                }
            },
            // 检查至少有一人绑定过微信
            checkLeastOnePersonBoundWeChat:function(){
              for(var i=0;i<this.cloudTrailWarningForm.noticeType.length;i++){
                  if(this.cloudTrailWarningForm.noticeType[i]==1){
                      var weChatDate={
                          "contactType":this.cloudTrailWarningForm.contactType
                      };
                      // 联系方式为 -联系人-
                      if(this.cloudTrailWarningForm.contactType==0){
                          weChatDate.userIds=this.cloudTrailWarningForm.userIdList;
                      }
                      // 联系方式为 -联系人组-
                      else if(this.cloudTrailWarningForm.contactType==1){
                          weChatDate.contactGroupIds = this.cloudTrailWarningForm.contactGroupIds;
                      }
                      this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                      .then(res => {
                          if(res.data){
                            // 可以添加告警
                            this.wechatWarningVisible=false;
                            this.isAddOrEdit=false;
                          }else{
                            // 不可以添加微信告警
                            this.wechatWarningVisible=true;
                            this.isAddOrEdit=true;
                          }
                      })
                  }else if(this.cloudTrailWarningForm.noticeType[i]!=1){
                      this.wechatWarningVisible=false;
                      this.isAddOrEdit=false;
                  }
              }
            },
            // 联系人组
            listContactGroups:function(){
                this.$api.contactGroup.listContactGroupsByAccountId("accountId", this.cloudTrailWarningForm.account)
                .then(res => {
                    this.contactGroupIdList = res.data;
                })
            },
            // 切换联系人组
            changeContactGroupId:function(){
               this.checkLeastOnePersonBoundWeChat();
            },
            // 切换通知对象
            changeNotificationObject:function(val){
              this.cloudTrailWarningForm.userIdList=[];
              this.cloudTrailWarningForm.notificationObject=val;
              for(var i=0;i<this.cloudTrailWarningForm.notificationObject.length;i++){
                for(var j=0;j<this.notificationObjectList.length;j++){
                  if(this.cloudTrailWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                     this.cloudTrailWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                  }
                }
              }
              this.checkLeastOnePersonBoundWeChat();
            },
            // 切换联系方式
            changeContactType:function(){
              this.checkLeastOnePersonBoundWeChat();
            },
            /**************************************  查询  **************************************/
            // 查询CloudTrail事件
            queryCloudTrailSecurityEvents: function () {
                tableCloudTrailWarningVue.$api.cloudTrail.queryCloudTrailSecurityEvents()
                .then(res => {
                    this.cloudTrailNamesList = res.data;
                })
            },
            // 查询监控指标
            searchMonitorIndex: function () {
                tableCloudTrailWarningVue.$api.alertRule.searchMonitorIndex({
                    "monitorModule":this.monitorModule,
                    "accountId":this.cloudTrailWarningForm.account
                })
                .then(res => {
                    this.monitorIndexList = res.data;
                })
            },
            // 查询通知对象
            queryContacts: function () {
                tableCloudTrailWarningVue.$api.contact.queryContactsByAccountIdAndMonitorModule({
                  "monitorModule":this.monitorModule,
                  "accountId":this.cloudTrailWarningForm.account
                })
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                    this.cloudTrailWarningForm.notificationObject = res.data.defaultContactIds;
                })
            },
            // 查询报警方式
            alarmWay: function () {
                tableCloudTrailWarningVue.$api.alertRule.alarmWay("userName",getCookie(global.cookieName))
                .then(res => {
                    this.alarmWayList = res.data;
                })
            },
             // 查询报警延迟
            getAlarmDelay: function () {
                tableCloudTrailWarningVue.$api.alertRule.alarmDelay("userName",getCookie(global.cookieName))
                .then(res => {
                    this.alarmDelayList = res.data;
              })
            },
          // 查询监控时间段
          searchMonitorPeriod: function(){
            this.$api.alertRule.monitorPeriod("userName",getCookie(global.cookieName))
              .then(res => {
                this.monitorPeriodList = res.data;
              })
          },
            // 周期
            changeCycle: function () {
                // 查询阈值
                tableCloudTrailWarningVue.selectMonitorIndexDefault();
            },
            // 连续周期
            changeContinousCycle: function () {
                // 查询阈值
                tableCloudTrailWarningVue.selectMonitorIndexDefault();
            },
            // 统计数值
            changeStatisticsValue: function () {
                // 查询阈值
                tableCloudTrailWarningVue.selectMonitorIndexDefault();
            },
            // 关系符号
            changeRelationshipSign: function () {
                // 查询阈值
                tableCloudTrailWarningVue.selectMonitorIndexDefault();
                // 邮件模板
                tableCloudTrailWarningVue.selectTemplate();
            },
            // 根据用户名查询Account列表
            getAccount: function () {
                // 清空表格
                tableCloudTrailWarningVue.$api.account.queryAccounts("userName", getCookie(global.cookieName))
                .then(res => {
                    this.accountList = res.data;
                    for (var i = 0; i < this.accountList.length; i++) {
                        this.accountList[i].name = this.accountList[i].name + '(' + this.accountList[i].accountTypeName + ')';
                    }
                })
                // 查询阈值
                tableCloudTrailWarningVue.selectMonitorIndexDefault();
                // 查询方式
                tableCloudTrailWarningVue.alarmWay();
                 // 查询报警延时
                tableCloudTrailWarningVue.getAlarmDelay();
                //监控时段
                tableCloudTrailWarningVue.searchMonitorPeriod();
                // 查询监控事件
                tableCloudTrailWarningVue.queryCloudTrailSecurityEvents();
                // 监控模块查询关联的机器人列表
                tableCloudTrailWarningVue.listEnterpriseWechatRobotsByMonitorModule();
            },
            // 监控模块查询关联的机器人列表
            listEnterpriseWechatRobotsByMonitorModule:function(){
                tableCloudTrailWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                    "monitorModule":this.monitorModule
                })
                .then(res => {
                    this.enterpriseWechatRobotIdsList = res.data;
                })
            },
            // 选择账户
            changeAccount: function () {
                if (this.cloudTrailWarningForm.account == "" || this.cloudTrailWarningForm.account == null) {
                    return;
                }
                this.cloudTrailWarningForm.backupRegion = [];
                // 查询监控事件
                tableCloudTrailWarningVue.queryCloudTrailSecurityEvents();
                // 查询监控指标
                tableCloudTrailWarningVue.searchMonitorIndex();
                // 清空表格
                tableCloudTrailWarningVue.$api.account.queryAccountRegions("accountId", this.cloudTrailWarningForm.account)
                .then(res => {
                    this.backupRegionList = res.data;
                });
                // 查询通知对象
                tableCloudTrailWarningVue.queryContacts();
               // 查询联系人组
               tableCloudTrailWarningVue.listContactGroups();
            },
            /***********存储区域**************************/
            selectBackupRegionAll(){
                this.cloudTrailWarningForm.backupRegion = []
                if (this.singleBackupRegion) {
                    this.backupRegionList.map((item) => {
                        this.cloudTrailWarningForm.backupRegion.push(item.name)
                    })
                } else {
                    this.cloudTrailWarningForm.backupRegion = []
                }
            },
            // 切换存储区域
            changebackupRegion: function (val) {
                if (val.length === this.backupRegionList.length&&val.length!=0) {
                    this.singleBackupRegion = true
                } else {
                    this.singleBackupRegion = false
                }
            },
            /***********事件检查**************************/
            selectCloudTrailNamesAll(){
                this.cloudTrailWarningForm.cloudTrailNames = []
                if (this.singleCloudTrailNames) {
                    this.cloudTrailNamesList.map((item) => {
                        this.cloudTrailWarningForm.cloudTrailNames.push(item.awsEventName)
                    })
                } else {
                    this.cloudTrailWarningForm.cloudTrailNames = []
              }
            },
            // 切换事件检查
            changeCloudTrailNames: function (val) {
                if (val.length === this.cloudTrailNamesList.length&&val.length!=0) {
                    this.singleCloudTrailNames = true
                } else {
                    this.singleCloudTrailNames = false
                }
            },
            // 创建添加或编辑报警
            /**********************************************************************************/
            ok: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        var alertList = {
                            "alertRuleName": this.cloudTrailWarningForm.ruleName,
                            "monitorIndex": this.cloudTrailWarningForm.monitorIndex,
                            "cycle": this.cloudTrailWarningForm.cycle,
                            "continousCycle": this.cloudTrailWarningForm.continousCycle,
                            "statisticsValue": this.cloudTrailWarningForm.statisticsValue,
                            "relationshipSign": this.cloudTrailWarningForm.relationshipSign,
                            "accountId": this.cloudTrailWarningForm.account,
                            "monitorModule": this.monitorModule,
                            "noticeType": this.cloudTrailWarningForm.noticeType,
                            "unit": this.units,
                            "delay":this.cloudTrailWarningForm.alarmDelay,
                             "monitorPeriod":this.cloudTrailWarningForm.monitorPeriod,
                            "thresholdValue":this.cloudTrailWarningForm.thresholdValue,
                            "regions":this.cloudTrailWarningForm.backupRegion,
                            "contactType":this.cloudTrailWarningForm.contactType,
                            "cloudTrailNames":this.cloudTrailWarningForm.cloudTrailNames,
                            "enterpriseWechatRobotIds":this.cloudTrailWarningForm.enterpriseWechatRobotIds
                        };

                        // 如果联系方式是联系人 传通知对象
                        if(this.cloudTrailWarningForm.contactType == 0){
                            alertList.contactIDs = this.cloudTrailWarningForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.cloudTrailWarningForm.contactType == 1){
                          alertList.contactGroupIds = this.cloudTrailWarningForm.contactGroupIds;
                        }

                        if (this.cloudTrailWarningForm.id > 0) {
                            alertList.id = this.cloudTrailWarningForm.id;
                            // 编辑告警
                            this.addloading=true;
                            tableCloudTrailWarningVue.$api.alertRule.updateAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        this.cloudTrailWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$emit('on-ok', this.form);
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success('编辑成功');
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        } else {
                            // 添加告警
                            this.addloading=true;
                            tableCloudTrailWarningVue.$api.alertRule.createAlertRule(alertList)
                                .then(res => {
                                    this.data = res.data;
                                    setTimeout(() => {
                                        this.reload();
                                        this.cloudTrailWarningForm.notificationObject = [];
                                        this.$refs[name].resetFields();
                                        this.loading = false;
                                        this.$nextTick(() => {
                                            this.loading = true;
                                        });
                                        this.$Message.success('添加成功');
                                        this.monitorIndexList=[];
                                        this.isShowEmail = false;
                                        this.isShowWeChat = false;
                                        this.addloading=false;
                                        this.modal = false;
                                        this.wechatWarningVisible=false;
                                        this.isAddOrEdit=true;
                                    }, 1000);
                                })
                        }
                    } else {
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        if (this.cloudTrailWarningForm.id > 0) {
                            this.$Message.error('编辑失败');
                        } else {
                            this.$Message.error('添加失败');
                        }
                    }
                });
            },
            // 取消
            cancel: function (name) {
                this.wechatWarningVisible=false;
                this.isAddOrEdit=true;
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.cloudTrailWarningForm.notificationObject = [];
                this.monitorIndexList=[];
                this.$nextTick(() => {
                    this.$refs[name].resetFields();
                });
                this.modal = false;
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/cloudTrail/cloudTrail_monitor/AddOrUpdateCloudTrailWarning.vue